function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLeft(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#040000",
    d: "M64.828 15.173a4 4 0 010 5.656L39.657 46.001l25.171 25.172a4 4 0 11-5.656 5.656l-28-28a4 4 0 010-5.656l28-28c.781-.781 1.805-1.172 2.828-1.172s2.047.391 2.828 1.172z"
  }));
}

SvgLeft.clsName = 'icon-www__left';
SvgLeft.remarkName = 'unknown';
export default SvgLeft;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Left.js
// module id = 2376
// module chunks = 17 18